import { createContext, useState } from 'react';

interface ITableTitleWrapperProvider {
  children: React.ReactNode;
}

interface ITableTitleWrapperContext {
  viewShowMore: boolean;
  setViewShowMore: (...args: any) => void;
}

export const TableTitleWrapperContext =
  createContext<ITableTitleWrapperContext | null>(null);

export const TableTitleWrapperProvider: React.FC<
  ITableTitleWrapperProvider
> = ({ children }) => {
  const [viewShowMore, setViewShowMore] = useState<boolean>(false);

  return (
    <TableTitleWrapperContext.Provider
      value={{
        viewShowMore,
        setViewShowMore,
      }}
    >
      {children}
    </TableTitleWrapperContext.Provider>
  );
};
